import { useState } from "react";
import Buttons from "../../../components/Buttons/Buttons";
import { customInstance } from "../../../api/custom-instance";
import { User } from "../../../api/models";

export default function ResetPasswordModal({ isOpen, onClose, user, setPopupMessage }: {
    isOpen: boolean,
    onClose: () => void,
    user: User | null,
    setPopupMessage: (msg: string, success: boolean) => void,
}) {
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!user || !password) return;
        setIsSubmitting(true);
        try {
            await customInstance({
                url: `users/${user.username}/password`,
                method: 'PUT',
                data: { password },
            });
            setPopupMessage(`Password reset for '${user.username}'.`, true);
            setPassword('');
            onClose();
        } catch (err: any) {
            const detail = err?.response?.data?.detail || 'Failed to reset password.';
            setPopupMessage(detail, false);
        }
        setIsSubmitting(false);
    };

    if (!isOpen || !user) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-lg w-full max-w-[400px] p-6 flex flex-col gap-4">
                <h2 className="text-lg font-semibold text-default">Reset Password — {user.username}</h2>
                <input className="border border-outline rounded px-3 py-2 text-sm" type="password" placeholder="New Password" value={password} onChange={e => setPassword(e.target.value)} />
                <div className="flex justify-end gap-2 mt-2">
                    <Buttons id="cancel-password" type="tertiary" styling="outline" label="Cancel" action={onClose} />
                    <Buttons id="save-password" type={(!password || isSubmitting) ? 'disabled' : 'primary'} styling="solid" label={isSubmitting ? 'Resetting...' : 'Reset Password'} action={handleSubmit} />
                </div>
            </div>
        </div>
    );
}
